export const GIFT_CURRENCY = "usd" as const;
export const GIFT_MIN_CENTS = 2500;
export const GIFT_MAX_CENTS = 100000;
export const GIFT_AMOUNTS = [50, 100, 150, 250, 500] as const;
export const GIFT_ANIMALS = [
  {
    id: "whale",
    name: "Humpback whale",
    subtitle: "For a soul as deep as the ocean.",
    image: "/gifts/whale.webp",
  },
  {
    id: "manta",
    name: "Manta ray",
    subtitle: "For the one who dreams of flying underwater.",
    image: "/gifts/manta.webp",
  },
  {
    id: "turtle",
    name: "Sea turtle",
    subtitle: "For someone who takes the scenic route.",
    image: "/gifts/turtle.webp",
  },
] as const;
export type GiftAnimal = (typeof GIFT_ANIMALS)[number]["id"];
export const giftAnimal = (id: string) =>
  GIFT_ANIMALS.find((animal) => animal.id === id) ?? GIFT_ANIMALS[0];
export const formatGiftAmount = (cents: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);

/** Convert decimal input without binary floating-point rounding or exponent syntax. */
export function giftAmountToCents(input: string): number | null {
  const value = input.trim();
  if (!/^\d{1,5}(?:\.\d{1,2})?$/.test(value)) return null;
  const [whole, fraction = ""] = value.split(".");
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
  return cents >= GIFT_MIN_CENTS && cents <= GIFT_MAX_CENTS ? cents : null;
}
